export function formatSubscriptionDate(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/** Last login for admin locale/TZ; null/invalid → "Never". */
export function formatLastLogin(value: string | null | undefined): string {
  if (!value) return 'Never';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Never';
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatDaysRemaining(days: number | null | undefined): string {
  if (days == null) return '—';
  if (days === 0) return '0 days';
  return `${days} day${days === 1 ? '' : 's'}`;
}

export function toIsoStartOfDay(dateStr: string): string {
  return new Date(`${dateStr}T00:00:00`).toISOString();
}

export function toIsoEndOfDay(dateStr: string): string {
  return new Date(`${dateStr}T23:59:59.999`).toISOString();
}

/** ISO-8601 now for admin filter query params. */
export function isoNow(): string {
  return new Date().toISOString();
}

/** ISO-8601 timestamp `days` after now (UTC calendar days). */
export function isoDaysFromNow(days: number): string {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString();
}

/** Local calendar YYYY-MM-DD for date inputs. */
export function toLocalDateInputValue(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function defaultEndingSoonDateInputs(days: number = 7): { from: string; to: string } {
  const from = new Date();
  const to = new Date();
  to.setDate(to.getDate() + days);
  return { from: toLocalDateInputValue(from), to: toLocalDateInputValue(to) };
}

/** Resolve ending-soon ISO range: default next 7 days, or custom date inputs. */
export function resolveEndingSoonRange(options: {
  useCustomRange: boolean;
  endsFrom: string;
  endsTo: string;
}): { from: string; to: string } | null {
  if (!options.useCustomRange) {
    return { from: isoNow(), to: isoDaysFromNow(7) };
  }
  if (!options.endsFrom.trim() || !options.endsTo.trim()) {
    return null;
  }
  return {
    from: toIsoStartOfDay(options.endsFrom.trim()),
    to: toIsoEndOfDay(options.endsTo.trim()),
  };
}

export const SPORT_LABELS: Record<string, string> = {
  MFB: "Men's Football",
  MBB: "Men's Basketball",
  WBB: "Women's Basketball",
  WVB: "Women's Volleyball",
  MVB: "Men's Volleyball",
  MSO: "Men's Soccer",
  WSO: "Women's Soccer",
  MIH: "Men's Ice Hockey",
  WIH: "Women's Ice Hockey",
};

export function getSportLabel(code: string): string {
  const key = (code || '').trim().toUpperCase();
  return SPORT_LABELS[key] ?? code;
}
